import { render } from "./ArrowRightIcon.vue?vue&type=template&id=c7357e34"
const script = {}

import exportComponent from "D:\\a\\1\\s\\Host\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__